import MainLayout from "@/components/layout/admin/MainLayout.vue";
// import Pagination from "laravel-vue-pagination";
import axios from "axios";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';

export default {
    name: "categoryList",
    components: {
        MainLayout,
        // Pagination,
        AdvancedLaravelVuePaginate
    },

    data() {
        return {
            categories: {},
            keyword: "",
            page_status: false
        };
    },

    methods: {
        getCategory(page = 1) {
            axios.get("/category/list?page=" + page)
                .then(response => {
                    this.categories = response.data;
                })
                .catch(error => {
                    console.log("Category List API Error", error);
                });
        },

        showCreate() {
            this.$router.replace({
                path: "/admin/category/create"
            });
        },

        confirmDelete(id) {
            if (window.confirm("Are you sure?")) {
                this.deleteCategory(id);
            } else {
                console.log("no");
            }
        },

        deleteCategory(id) {
            axios.delete("/category/delete/" + id)
                .then(response => {
                    this.categories = response.data;
                    this.getCategory();
                })
                .catch(error => {
                    console.log("Category Delete Error->", error.response.data);
                });
        },

        searchCategory(page = 1) {
            var request = {
                params: {
                    keyword: this.keyword
                }
            }
            axios.get("/category/search/result?page="+page, request)
                .then(response => {
                    this.page_status = true;
                    this.categories = response.data;
                })
                .catch(error => {
                    console.log("Category Search API Error", error);
                });
        }
    },

    mounted() {
        this.getCategory();
    }
};